(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  (() => {
    if (window.shoonyasCatalogLoadMoreInitialized) return;
    window.shoonyasCatalogLoadMoreInitialized = true;

    const buttonSelector = '[data-catalog-load-more]';
    const defaultDoneText = "You've seen all our drapes.";

    const getCatalogElements = (button) => {
      const resultsList = button.closest('results-list[data-shoonyas-load-more-page="true"]');
      const grid = resultsList?.querySelector('[ref="grid"]');
      const wrapper = button.closest('.shoonyas-catalog-load-more');

      return { resultsList, grid, wrapper };
    };

    const getNextUrl = (page, sectionId) => {
      const url = new URL(window.location.href);
      url.searchParams.set('page', String(page));
      if (sectionId) url.searchParams.set('section_id', sectionId);
      url.hash = '';
      return url;
    };

    const appendCatalogCards = (grid, cards) => {
      grid.append(...cards);
    };

    const setDoneState = (wrapper) => {
      if (!wrapper) return;
      const resultsList = wrapper.closest('results-list[data-shoonyas-load-more-page="true"]');
      const doneText = resultsList?.dataset.catalogDoneLabel || defaultDoneText;
      wrapper.innerHTML = `<p class="shoonyas-catalog-load-more__done">${doneText}</p>`;
    };

    let activeRequest = false;

    document.addEventListener('click', async (event) => {
      const button = event.target.closest(buttonSelector);
      if (!button || button.disabled || activeRequest) return;
      event.preventDefault();
      button.blur();

      const { resultsList, grid, wrapper } = getCatalogElements(button);
      if (!resultsList || !grid || !wrapper) return;

      const label = button.querySelector('[data-catalog-load-more-label]');
      const defaultLabel = button.dataset.defaultLabel || 'View More Sarees';
      const nextPage = Number(button.dataset.nextPage || 2);
      const lastPage = Number(button.dataset.lastPage || grid.dataset.lastPage || 1);
      const scrollBeforeLoad = window.scrollY;

      activeRequest = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (label) label.textContent = 'Loading...';

      try {
        const response = await fetch(getNextUrl(nextPage, resultsList.getAttribute('section-id')), {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });

        if (!response.ok) throw new Error(`Catalog page ${nextPage} failed to load`);

        const html = await response.text();
        const parsedPage = new DOMParser().parseFromString(html, 'text/html');
        const nextGrid = parsedPage.querySelector('results-list[data-shoonyas-load-more-page="true"] [ref="grid"]');
        const nextCards = Array.from(nextGrid?.querySelectorAll(':scope > [ref="cards[]"]') || []);

        if (!nextCards.length) {
          setDoneState(wrapper);
          return;
        }

        appendCatalogCards(grid, nextCards);

        requestAnimationFrame(() => {
          if (Math.abs(window.scrollY - scrollBeforeLoad) > 2) {
            window.scrollTo({ top: scrollBeforeLoad, behavior: 'instant' });
          }
        });

        const parsedLastPage = Number(nextGrid?.dataset.lastPage || lastPage);
        const followingPage = nextPage + 1;

        if (followingPage > parsedLastPage) {
          setDoneState(wrapper);
          return;
        }

        button.dataset.nextPage = String(followingPage);
        button.dataset.lastPage = String(parsedLastPage);
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (label) label.textContent = defaultLabel;
      } catch (error) {
        console.error(error);
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (label) label.textContent = defaultLabel;
      } finally {
        activeRequest = false;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watch-and-shop"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-shoonyas-watch-shop]:not([data-watch-shop-ready])');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const desktopHoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

    sections.forEach((section) => {
      section.dataset.watchShopReady = 'true';

      const autoplayEnabled = section.dataset.autoplay === 'true' && !reduceMotion.matches;
      const lightboxEnabled = section.dataset.lightboxEnabled !== 'false';
      const mutedDefault = section.dataset.mutedDefault !== 'false';
      const cards = Array.from(section.querySelectorAll('[data-watch-card]'));
      const lightbox = section.querySelector('[data-lightbox]');
      const lightboxContent = section.querySelector('[data-lightbox-content]');
      const playLightbox = section.querySelector('[data-lightbox-play]');
      const muteLightbox = section.querySelector('[data-lightbox-mute]');
      const debugVideoQuality = window.location.search.includes('preview_theme_id') || Boolean(window.Shopify?.designMode);
      let watchShopMuted = mutedDefault;
      let lightboxMutedPreference = null;
      let activeCard = null;
      let observerActiveCard = null;
      let hoverCard = null;
      let activeLightboxIndex = 0;
      let sectionVisible = false;
      let lightboxOpen = false;
      let autoplayRetried = false;
      let initialAutoplayRetried = false;
      let restoreFocus = null;
      let touchStartY = 0;
      let touchStartX = 0;
      let wheelLocked = false;
      let cardOpenLocked = false;
      let closeTimer;

      const loadVideo = (video) => {
        if (!video || video.dataset.loaded === 'true') return;
        video.querySelectorAll('source[data-src]').forEach((source) => {
          source.src = source.dataset.src;
          if (debugVideoQuality) console.log('WatchShop video source:', source.src);
          source.removeAttribute('data-src');
        });
        video.dataset.loaded = 'true';
        video.load();
      };

      const logVideoDimensions = (video) => {
        if (!debugVideoQuality || !video) return;
        const source = video.currentSrc || video.querySelector('source')?.src || '';
        console.log('WatchShop video source:', source);
        console.log('WatchShop video dimensions:', video.videoWidth, video.videoHeight);
      };

      const logVideoSource = (video) => {
        if (!debugVideoQuality || !video) return;
        console.log('WatchShop video source:', video.currentSrc || video.querySelector('source')?.src || '');
      };

      const setIconState = (button, isActive) => {
        if (!button) return;
        const idleIcons = button.querySelectorAll('[data-icon-play], [data-icon-muted]');
        const activeIcons = button.querySelectorAll('[data-icon-pause], [data-icon-unmuted]');
        idleIcons.forEach((icon) => { icon.hidden = isActive; });
        activeIcons.forEach((icon) => { icon.hidden = !isActive; });
      };

      const pauseVideo = (video) => {
        if (!video) return;
        video.pause();
        updateCardControls(video.closest('[data-watch-card]'));
      };

      const playVideo = (video) => {
        if (!video) return Promise.resolve();
        loadVideo(video);
        video.muted = watchShopMuted;
        const playAttempt = video.play();
        if (playAttempt && typeof playAttempt.catch === 'function') {
          playAttempt.catch(() => {});
        }
        updateCardControls(video.closest('[data-watch-card]'));
        return playAttempt || Promise.resolve();
      };

      const updateProgress = (video, progress) => {
        if (!video || !progress || !Number.isFinite(video.duration) || video.duration <= 0) return;
        progress.style.transform = `scaleX(${Math.min(video.currentTime / video.duration, 1)})`;
      };

      const updateCardControls = (card) => {
        if (!card) return;
        const video = card.querySelector('[data-watch-video]');
        const muteButton = card.querySelector('[data-mute-toggle]');
        if (muteButton && video) setIconState(muteButton, !video.muted);
        if (muteButton && video) muteButton.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      };

      const updateActiveCards = () => {
        cards.forEach((card) => {
          const isActive = card === activeCard;
          card.classList.toggle('is-active', isActive);
          card.classList.toggle('is-sound-visible', isActive && card.dataset.userInteracted === 'true');
        });
      };

      const pauseAllCardsExcept = (exceptCard = null) => {
        cards.forEach((item) => {
          if (item !== exceptCard) pauseVideo(item.querySelector('[data-watch-video]'));
        });
      };

      const tryAutoplayActive = (allowRetry = false) => {
        if (!autoplayEnabled || !sectionVisible || lightboxOpen) return;
        const card = activeCard || cards[0];
        if (!card || card.dataset.userPaused === 'true') return;
        pauseAllCardsExcept(card);
        const attempt = playVideo(card.querySelector('[data-watch-video]'));
        if (allowRetry && attempt && typeof attempt.catch === 'function') {
          attempt.catch(() => {
            if (autoplayRetried) return;
            autoplayRetried = true;
            window.setTimeout(() => {
              if (sectionVisible && !lightboxOpen && card.dataset.userPaused !== 'true') {
                playVideo(card.querySelector('[data-watch-video]'));
              }
            }, 300);
          });
        }
      };

      const setActiveCard = (card) => {
        if (!card) return;
        pauseAllCardsExcept(card);
        activeCard = card;
        updateActiveCards();
        if (autoplayEnabled && sectionVisible && !lightboxOpen && card.dataset.userPaused !== 'true') playVideo(card.querySelector('[data-watch-video]'));
      };

      const playHoveredCard = (card) => {
        if (lightboxOpen) return;
        hoverCard = card;
        pauseAllCardsExcept(card);
        activeCard = card;
        updateActiveCards();
        const video = card.querySelector('[data-watch-video]');
        if (!video) return;
        loadVideo(video);
        video.muted = watchShopMuted;
        video.play().catch(() => {});
        updateCardControls(card);
      };

      const restoreObserverCard = () => {
        hoverCard = null;
        if (lightboxOpen) return;
        setActiveCard(observerActiveCard || activeCard || cards[0]);
      };

      const openCardLightbox = (event, card) => {
        if (event.target.closest('a, button')) return;
        if (!lightboxEnabled || cardOpenLocked) return;
        cardOpenLocked = true;
        window.setTimeout(() => { cardOpenLocked = false; }, 350);
        openLightbox(Number(card.dataset.index), card);
      };

      const resumeActiveCarouselVideo = () => {
        if (!autoplayEnabled || !sectionVisible || lightboxOpen) return;
        const card = activeCard || cards[0];
        if (card && card.dataset.userPaused !== 'true') {
          pauseAllCardsExcept(card);
          playVideo(card.querySelector('[data-watch-video]'));
        }
      };

      const cardObserver = new IntersectionObserver((entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (visible && visible.intersectionRatio >= 0.55) {
          observerActiveCard = visible.target;
          if (!hoverCard) setActiveCard(visible.target);
        }
        entries.forEach((entry) => {
          const video = entry.target.querySelector('[data-watch-video]');
          if (!entry.isIntersecting) {
            entry.target.dataset.userPaused = 'false';
            pauseVideo(video);
          } else if (entry.intersectionRatio > 0.2) {
            loadVideo(video);
          }
        });
      }, { root: null, threshold: [0, 0.2, 0.55, 0.8] });

      const sectionObserver = new IntersectionObserver((entries) => {
        const entry = entries[0];
        sectionVisible = Boolean(entry?.isIntersecting);
        if (!sectionVisible) {
          cards.forEach((card) => pauseVideo(card.querySelector('[data-watch-video]')));
          return;
        }

        if (!activeCard && cards[0]) activeCard = cards[0];
        updateActiveCards();
        tryAutoplayActive(true);
      }, { threshold: 0.3 });

      cards.forEach((card) => {
        const video = card.querySelector('[data-watch-video]');
        const muteButton = card.querySelector('[data-mute-toggle]');
        const progress = card.querySelector('[data-progress]');
        let pointerStartX = 0;
        let pointerStartY = 0;

        if (video) {
          video.muted = watchShopMuted;
          video.addEventListener('timeupdate', () => updateProgress(video, progress));
          video.addEventListener('play', () => updateCardControls(card));
          video.addEventListener('pause', () => updateCardControls(card));
          video.addEventListener('loadedmetadata', () => logVideoDimensions(video));
        }

        muteButton?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (!video) return;
          card.dataset.userInteracted = 'true';
          card.classList.add('is-interacted');
          watchShopMuted = !video.muted;
          cards.forEach((item) => {
            const itemVideo = item.querySelector('[data-watch-video]');
            if (itemVideo) itemVideo.muted = watchShopMuted;
            updateCardControls(item);
          });
        });

        video?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          openCardLightbox(event, card);
        });

        card.querySelectorAll('.shoonyas-watch-shop__cta').forEach((cta) => {
          cta.addEventListener('click', (event) => {
            event.stopPropagation();
          });
        });

        card.addEventListener('click', (event) => {
          openCardLightbox(event, card);
        });

        card.addEventListener('pointerdown', (event) => {
          pointerStartX = event.clientX;
          pointerStartY = event.clientY;
        });

        card.addEventListener('pointerup', (event) => {
          if (Math.abs(event.clientX - pointerStartX) > 12 || Math.abs(event.clientY - pointerStartY) > 12) return;
          openCardLightbox(event, card);
        });

        card.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          if (lightboxEnabled) {
            openLightbox(Number(card.dataset.index), card);
          }
        });

        card.addEventListener('mouseenter', () => {
          if (desktopHoverQuery.matches) playHoveredCard(card);
        });

        card.addEventListener('mouseleave', () => {
          if (desktopHoverQuery.matches) restoreObserverCard();
        });

        cardObserver.observe(card);
        updateCardControls(card);
      });

      if (cards[0]) activeCard = cards[0];
      updateActiveCards();
      sectionObserver.observe(section);
      window.setTimeout(() => {
        if (initialAutoplayRetried) return;
        initialAutoplayRetried = true;
        tryAutoplayActive(true);
      }, 300);

      const trapFocus = (event) => {
        if (event.key !== 'Tab' || !lightbox || lightbox.hidden) return;
        const focusable = Array.from(lightbox.querySelectorAll('button, a[href], video, [tabindex]:not([tabindex="-1"])'))
          .filter((element) => !element.disabled && element.offsetParent !== null);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      };

      const getLightboxVideo = () => lightbox?.querySelector('[data-lightbox-video]');

      const updateLightboxControls = () => {
        const video = getLightboxVideo();
        const controls = section.querySelector('.shoonyas-watch-shop__lightbox-controls');
        if (controls) controls.hidden = !video;
        if (!video) return;
        if (playLightbox) {
          setIconState(playLightbox, !video.paused);
          playLightbox.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
        }
        if (muteLightbox) {
          const isAudible = !video.muted && video.volume > 0;
          setIconState(muteLightbox, isAudible);
          muteLightbox.setAttribute('aria-label', isAudible ? 'Mute video' : 'Unmute video');
        }
      };

      const bindLightboxVideoEvents = (video) => {
        video.addEventListener('play', updateLightboxControls);
        video.addEventListener('pause', updateLightboxControls);
        video.addEventListener('ended', updateLightboxControls);
        video.addEventListener('loadedmetadata', updateLightboxControls);
        video.addEventListener('canplay', updateLightboxControls);
        video.addEventListener('volumechange', updateLightboxControls);
      };

      function renderLightbox(index, direction = 'next') {
        if (!lightboxContent) return;
        activeLightboxIndex = (index + cards.length) % cards.length;
        activeCard = cards[activeLightboxIndex];
        updateActiveCards();
        const template = cards[activeLightboxIndex].querySelector('[data-lightbox-template]');
        lightboxContent.classList.remove('is-next', 'is-prev');
        lightboxContent.replaceChildren(template.content.cloneNode(true));
        lightboxContent.classList.add(direction === 'prev' ? 'is-prev' : 'is-next');
        window.setTimeout(() => {
          lightboxContent.classList.remove('is-next', 'is-prev');
        }, 280);
        const video = getLightboxVideo();
        const videoWrap = lightbox.querySelector('.shoonyas-watch-shop__lightbox-video-wrap');
        if (videoWrap) {
          videoWrap.addEventListener('touchstart', onLightboxTouchStart, { passive: true });
          videoWrap.addEventListener('touchmove', onLightboxTouchMove, { passive: false });
          videoWrap.addEventListener('touchend', onLightboxTouchEnd, { passive: true });
        }
        pauseAllCardsExcept(null);
        if (video) {
          const progressLightbox = lightbox.querySelector('[data-lightbox-progress]');
          const requestedMuted = lightboxMutedPreference === null ? false : lightboxMutedPreference;
          video.muted = requestedMuted;
          logVideoSource(video);
          video.addEventListener('timeupdate', () => updateProgress(video, progressLightbox));
          bindLightboxVideoEvents(video);
          video.addEventListener('loadedmetadata', () => logVideoDimensions(video));
          video.addEventListener('click', () => {
            if (video.paused) {
              video.play().then(updateLightboxControls).catch(updateLightboxControls);
            } else {
              video.pause();
              updateLightboxControls();
            }
          });
          video.play().then(updateLightboxControls).catch(() => {
            if (!video.muted) {
              video.muted = true;
              video.play().then(updateLightboxControls).catch(updateLightboxControls);
            } else {
              updateLightboxControls();
            }
          });
        }
        updateLightboxControls();
      }

      const showNextLightboxReel = () => renderLightbox(activeLightboxIndex + 1, 'next');
      const showPrevLightboxReel = () => renderLightbox(activeLightboxIndex - 1, 'prev');

      function openLightbox(index, trigger) {
        if (!lightbox || !cards.length) return;
        window.clearTimeout(closeTimer);
        restoreFocus = trigger;
        lightboxOpen = true;
        lightbox.hidden = false;
        lightbox.classList.remove('is-closing');
        renderLightbox(index, 'next');
        document.documentElement.classList.add('shoonyas-watch-shop-lightbox-open');
        document.body.classList.add('shoonyas-watch-shop-lightbox-open');
        lightbox.querySelector('[data-lightbox-close]')?.focus();
        document.addEventListener('keydown', onLightboxKeydown);
      }

      function closeLightbox() {
        if (!lightbox) return;
        const video = getLightboxVideo();
        if (video) video.pause();
        lightboxOpen = false;
        lightbox.classList.add('is-closing');
        document.documentElement.classList.remove('shoonyas-watch-shop-lightbox-open');
        document.body.classList.remove('shoonyas-watch-shop-lightbox-open');
        document.removeEventListener('keydown', onLightboxKeydown);
        closeTimer = window.setTimeout(() => {
          lightbox.hidden = true;
          lightbox.classList.remove('is-closing');
          lightboxContent?.replaceChildren();
          resumeActiveCarouselVideo();
          restoreFocus?.focus();
        }, 220);
      }

      function onLightboxKeydown(event) {
        if (event.key === 'Escape') closeLightbox();
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') showPrevLightboxReel();
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') showNextLightboxReel();
        trapFocus(event);
      }

      const handleLightboxSwipeDelta = (delta) => {
        if (Math.abs(delta) < 50) return;
        if (delta < 0) showNextLightboxReel();
        else showPrevLightboxReel();
      };

      function onLightboxTouchStart(event) {
        event.stopPropagation();
        const touch = event.changedTouches[0];
        touchStartY = touch.clientY;
        touchStartX = touch.clientX;
      }

      function onLightboxTouchMove(event) {
        event.stopPropagation();
        if (!lightbox.hidden) event.preventDefault();
      }

      function onLightboxTouchEnd(event) {
        event.stopPropagation();
        const touch = event.changedTouches[0];
        const deltaY = touch.clientY - touchStartY;
        const deltaX = touch.clientX - touchStartX;
        if (Math.abs(deltaY) < Math.abs(deltaX)) return;
        handleLightboxSwipeDelta(deltaY);
      }

      lightbox?.addEventListener('wheel', (event) => {
        if (lightbox.hidden || wheelLocked || Math.abs(event.deltaY) < 20) return;
        event.preventDefault();
        wheelLocked = true;
        if (event.deltaY > 0) showNextLightboxReel();
        else showPrevLightboxReel();
        window.setTimeout(() => { wheelLocked = false; }, 650);
      }, { passive: false });

      section.querySelectorAll('[data-lightbox-close]').forEach((button) => {
        button.addEventListener('click', closeLightbox);
      });

      playLightbox?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const video = getLightboxVideo();
        if (!video) return;
        if (video.paused) {
          video.play().then(updateLightboxControls).catch(updateLightboxControls);
        } else {
          video.pause();
          updateLightboxControls();
        }
      });

      muteLightbox?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const video = getLightboxVideo();
        if (!video) return;
        const shouldMute = !video.muted && video.volume > 0;
        lightboxMutedPreference = shouldMute;
        video.muted = shouldMute;
        updateLightboxControls();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
